import Feature from "../Feature";
import { userStore } from "../store";

const hasFeature = (feature: Feature) => userStore.user?.features.includes(feature);

export default hasFeature;
